export default [
  {
    path: '/fpt-connect/:key?',
    name: 'fptConnectIndex',
    component: () => import('@/views/fptConnect/FptConnectIndex.vue'),
    meta: {},
  },
];
